import React, { useState } from 'react'

import Modal from 'react-bootstrap/Modal'
import Stack from 'react-bootstrap/Stack'
import Button from 'react-bootstrap/Button'

import { Spinner } from '../../LoadingContainer/Spinner'
import { useModal } from '../../../providers/ModalProvider/ModalProvider'
import { sendOrderToUser } from '../../../utilities/api'
import Success from '../Success/Success'
import Error from '../Error/Error'

import AuthService from '../../../utilities/services/auth.service'

export default function ConfirmSendTickets({ order, onSuccess }) {
  const { closeModal } = useModal()
  const [sending, setSending] = useState(false)
  const [modalState, setModalState] = useState('base')
  const organization = AuthService.getOrg()
  // Transfers and exchanges copy packageOrder off the order the seats came out
  // of, so the flag alone says nothing about what this order delivers. Only a
  // linked package or season seats of its own make it a package delivery.
  const isPackageOrder = Boolean(
    order?.package || order?.package_tickets?.length
  )
  const isAccessPass = Boolean(
    !isPackageOrder &&
    (order?.access_pass_template || order?.access_passes?.length)
  )
  const isFlexPackPurchase = Boolean(order?.flex_pack && !order?.voucher)
  const isResend = Boolean(order?.emailSent)
  const itemLabel = isAccessPass
    ? 'Access Pass'
    : isPackageOrder
      ? 'package'
      : isFlexPackPurchase
        ? 'vouchers'
        : 'tickets'
  const actionLabel = `${isResend ? 'Resend' : 'Send'} ${itemLabel}`
  const itemLabelSentenceStart =
    itemLabel.charAt(0).toUpperCase() + itemLabel.slice(1)

  const onConfirm = async () => {
    setSending(true)
    const data = {
      order: order,
      organizationUUID: organization?.[0]?.uuid,
    }

    try {
      await sendOrderToUser(data)
      setModalState('success')
      try {
        onSuccess?.()
      } catch (callbackErr) {
        console.warn(
          `${actionLabel} succeeded but onSuccess callback failed:`,
          callbackErr
        )
      }
    } catch (err) {
      console.log('err: ', err)
      setModalState('error')
    } finally {
      setSending(false)
    }
  }

  if (modalState === 'error') {
    return (
      <Error
        title={`Error ${isResend ? 'resending' : 'sending'} ${itemLabel}...`}
        description=""
        onClose={closeModal}
      />
    )
  }

  if (modalState === 'success') {
    return (
      <Success
        title={`${itemLabelSentenceStart} sent to user!`}
        description=""
        onClose={closeModal}
      />
    )
  }

  return (
    <Modal.Body className="d-flex flex-column align-items-center justify-content-center text-center">
      <div className="modal-body-heading">
        <h1 className="modal-body-heading-title m-0">
          {actionLabel} to customer?
        </h1>
      </div>
      <p className="text-muted">
        A new delivery email will be sent to the customer associated with this
        order.
      </p>
      <Stack className="btn-group-flex">
        <Button
          variant="primary"
          size="lg"
          className="btn-width"
          onClick={onConfirm}
          disabled={sending}
        >
          {sending ? <Spinner variant="white" /> : actionLabel}
        </Button>
        <Button size="lg" variant="outline-light" onClick={closeModal}>
          Cancel
        </Button>
      </Stack>
    </Modal.Body>
  )
}
